// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Role edit modal ─────────────────────────────────────────────────────── */

.role-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* ── Header ── */
.role-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 24px 16px;
  background: #1a1a1a;
  flex-shrink: 0;
}

.role-modal__eyebrow {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #6b7280;
  margin: 0 0 4px;
}

.role-modal__title {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 6px;
}

.role-modal__id {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 11px;
  color: #9ca3af;
  background: #2d2d2d;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #404040;
}

/* ── Body: two-pane layout ── */
.role-modal__body {
  flex: 1 1;
  display: flex;
  overflow: hidden;
  min-height: 0;
}

.role-modal__fields {
  width: 280px;
  flex-shrink: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-right: 1px solid #e5e7eb;
  overflow-y: auto;
}

.role-modal__summary {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.role-modal__summary-count {
  font-size: 22px;
  font-weight: 800;
  color: #111827;
}

.role-modal__summary-label {
  font-size: 12px;
  color: #6b7280;
}

.role-modal__permissions {
  flex: 1 1;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* ── Namespace tab list (left) + full-height scope panel (right), one continuous panel ── */
.role-modal__tabbed {
  flex: 1 1;
  display: flex;
  overflow: hidden;
  min-height: 0;
}

.role-modal__tabs {
  width: 190px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 16px;
}

.role-modal__tabs-header {
  display: flex;
  align-items: center;
  height: 34px;
  box-sizing: content-box;
  padding-bottom: 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.role-modal__tabs-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
}

.role-modal__tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: none;
  border: none;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 2px;
  font-size: 12.5px;
  font-weight: 600;
  color: #4b5563;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}

.role-modal__tab:hover {
  background: #f3f4f6;
}

.role-modal__tab.active {
  background: #eef7e0;
  color: #3f6212;
}

.role-modal__tab-label {
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-size: 11px;
}

.role-modal__tab-count {
  font-size: 11px;
  font-weight: 700;
  color: #86BC25;
  flex-shrink: 0;
}

.role-modal__tab.active .role-modal__tab-count {
  color: #3f6212;
}

.role-modal__scope-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.role-modal__scope-panel-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 14px;
  min-height: 34px;
  box-sizing: content-box;
  padding-bottom: 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.role-modal__scope-panel-title {
  font-size: 13px;
  font-weight: 800;
  color: #111827;
  flex-shrink: 0;
}

.role-modal__scope-search {
  flex: 1 1 260px;
  min-width: 180px;
  height: 34px;
  box-sizing: border-box;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: text;
}

.role-modal__scope-search input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  border: none;
  outline: none;
  background: none;
  font: inherit;
  font-size: 12.5px;
  color: #111827;
  padding: 0;
  margin: 0;
  height: 100%;
  text-overflow: ellipsis;
}

.role-modal__scope-search input::placeholder {
  color: #9ca3af;
}

.role-modal__scope-panel-body {
  flex: 1 1;
  overflow-y: auto;
}

.role-modal__select-all {
  background: none;
  border: none;
  color: #0969da;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  margin-left: auto;
}

.role-modal__select-all:hover {
  text-decoration: underline;
}

.role-modal__checkbox-row {
  display: flex !important;
  margin-left: 0 !important;
  width: 100%;
}

.role-modal__checkbox-row .MuiFormControlLabel-label {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 11.5px;
  color: #1f2937;
  word-break: break-all;
}

.role-modal__checkbox-row .MuiFormControlLabel-label--implied {
  color: #9ca3af;
}

/* ── GitHub-style parent scope / child scope tree ── */
.role-modal__scope-tree {
  border-bottom: 1px solid #eceef1;
  padding-bottom: 4px;
  margin-bottom: 4px;
}

.role-modal__scope-tree:last-child {
  border-bottom: none;
}

.role-modal__checkbox-row--parent .MuiFormControlLabel-label {
  font-weight: 700;
  color: #111827;
}

.role-modal__scope-children {
  margin-left: 26px;
  border-left: 2px solid #e5e7eb;
  padding-left: 10px;
}

.role-modal__checkbox-row--child .MuiFormControlLabel-label {
  color: #4b5563;
}

/* ── Footer ── */
.role-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  flex-shrink: 0;
}

.role-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  transition: background 0.15s;
  font-family: inherit;
}

.role-modal__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.role-modal__btn--cancel {
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
}

.role-modal__btn--cancel:hover:not(:disabled) {
  background: #f3f4f6;
}

.role-modal__btn--save {
  background: #86BC25;
  color: #fff;
}

.role-modal__btn--save:hover:not(:disabled) {
  background: #6fa019;
}

/* ── Responsive: stack fields above permissions on narrower screens ── */
@media (max-width: 900px) {
  .role-modal__body {
    flex-direction: column;
    overflow-y: auto;
  }

  .role-modal__fields {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .role-modal__tabbed {
    flex-direction: column;
  }

  .role-modal__tabs {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    padding-right: 0;
    padding-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/accessManagement/components/RoleEditModal.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,4FAA4F;AAC5F;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":["/* ── Role edit modal ─────────────────────────────────────────────────────── */\n\n.role-modal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* ── Header ── */\n.role-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 20px 24px 16px;\n  background: #1a1a1a;\n  flex-shrink: 0;\n}\n\n.role-modal__eyebrow {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #6b7280;\n  margin: 0 0 4px;\n}\n\n.role-modal__title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #fff;\n  margin: 0 0 6px;\n}\n\n.role-modal__id {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 11px;\n  color: #9ca3af;\n  background: #2d2d2d;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid #404040;\n}\n\n/* ── Body: two-pane layout ── */\n.role-modal__body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.role-modal__fields {\n  width: 280px;\n  flex-shrink: 0;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  border-right: 1px solid #e5e7eb;\n  overflow-y: auto;\n}\n\n.role-modal__summary {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.role-modal__summary-count {\n  font-size: 22px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.role-modal__summary-label {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.role-modal__permissions {\n  flex: 1;\n  padding: 20px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n/* ── Namespace tab list (left) + full-height scope panel (right), one continuous panel ── */\n.role-modal__tabbed {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.role-modal__tabs {\n  width: 190px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding-right: 16px;\n}\n\n.role-modal__tabs-header {\n  display: flex;\n  align-items: center;\n  height: 34px;\n  box-sizing: content-box;\n  padding-bottom: 12px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.role-modal__tabs-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #9ca3af;\n}\n\n.role-modal__tab {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 2px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #4b5563;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n}\n\n.role-modal__tab:hover {\n  background: #f3f4f6;\n}\n\n.role-modal__tab.active {\n  background: #eef7e0;\n  color: #3f6212;\n}\n\n.role-modal__tab-label {\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  font-size: 11px;\n}\n\n.role-modal__tab-count {\n  font-size: 11px;\n  font-weight: 700;\n  color: #86BC25;\n  flex-shrink: 0;\n}\n\n.role-modal__tab.active .role-modal__tab-count {\n  color: #3f6212;\n}\n\n.role-modal__scope-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n}\n\n.role-modal__scope-panel-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  column-gap: 14px;\n  min-height: 34px;\n  box-sizing: content-box;\n  padding-bottom: 12px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.role-modal__scope-panel-title {\n  font-size: 13px;\n  font-weight: 800;\n  color: #111827;\n  flex-shrink: 0;\n}\n\n.role-modal__scope-search {\n  flex: 1 1 260px;\n  min-width: 180px;\n  height: 34px;\n  box-sizing: border-box;\n  background: #f3f4f6;\n  border-radius: 999px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: text;\n}\n\n.role-modal__scope-search input {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  border: none;\n  outline: none;\n  background: none;\n  font: inherit;\n  font-size: 12.5px;\n  color: #111827;\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  text-overflow: ellipsis;\n}\n\n.role-modal__scope-search input::placeholder {\n  color: #9ca3af;\n}\n\n.role-modal__scope-panel-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.role-modal__select-all {\n  background: none;\n  border: none;\n  color: #0969da;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.role-modal__select-all:hover {\n  text-decoration: underline;\n}\n\n.role-modal__checkbox-row {\n  display: flex !important;\n  margin-left: 0 !important;\n  width: 100%;\n}\n\n.role-modal__checkbox-row .MuiFormControlLabel-label {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 11.5px;\n  color: #1f2937;\n  word-break: break-all;\n}\n\n.role-modal__checkbox-row .MuiFormControlLabel-label--implied {\n  color: #9ca3af;\n}\n\n/* ── GitHub-style parent scope / child scope tree ── */\n.role-modal__scope-tree {\n  border-bottom: 1px solid #eceef1;\n  padding-bottom: 4px;\n  margin-bottom: 4px;\n}\n\n.role-modal__scope-tree:last-child {\n  border-bottom: none;\n}\n\n.role-modal__checkbox-row--parent .MuiFormControlLabel-label {\n  font-weight: 700;\n  color: #111827;\n}\n\n.role-modal__scope-children {\n  margin-left: 26px;\n  border-left: 2px solid #e5e7eb;\n  padding-left: 10px;\n}\n\n.role-modal__checkbox-row--child .MuiFormControlLabel-label {\n  color: #4b5563;\n}\n\n/* ── Footer ── */\n.role-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 24px;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n  flex-shrink: 0;\n}\n\n.role-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s;\n  font-family: inherit;\n}\n\n.role-modal__btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.role-modal__btn--cancel {\n  background: #fff;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.role-modal__btn--cancel:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.role-modal__btn--save {\n  background: #86BC25;\n  color: #fff;\n}\n\n.role-modal__btn--save:hover:not(:disabled) {\n  background: #6fa019;\n}\n\n/* ── Responsive: stack fields above permissions on narrower screens ── */\n@media (max-width: 900px) {\n  .role-modal__body {\n    flex-direction: column;\n    overflow-y: auto;\n  }\n\n  .role-modal__fields {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .role-modal__tabbed {\n    flex-direction: column;\n  }\n\n  .role-modal__tabs {\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n    padding-right: 0;\n    padding-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
